import { Route } from '@/core/entities/types/routes';
import Main from '@/core/views/main/main';
import { dynamicRouteChildren } from '@/modules/healthManage/routes/dynamicRouteChildern';
import { checkPermission, PERMISSIONS } from '@/utils/checkPermission';

const healthManagePermissions = [
  PERMISSIONS.COMPANY_DIGITAL_HOSPITAL_MANAGE,
  PERMISSIONS.COMPANY_HEALTH_DATA_MANAGE
]

const permissionsThatUserHas = healthManagePermissions.filter(permission => checkPermission(permission));
const routeChildren = dynamicRouteChildren({
  permissionsThatUserHas,
})

const routes: Route[] = [
  {
    path: '/health-manage',
    Component: Main,
    meta: routeChildren[0].meta,
    loader: routeChildren[0].loader,
    children: routeChildren,
  },
]

export default routes;
